module.exports = __webpack_public_path__ + "tempal-icons.59f78d608e80c81b318d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/tempal-icons/tempal-icons.ttf?c8otwj
// module id = 484
// module chunks = 5